import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Button, Image } from 'react-bootstrap';
import './SwitchNeighbourProfile.css';
import BusinessSidebar from "../../BusinessSidebar";
import Header from "../../BusinessHeaderAfterLogin";
import Footer from "../../BusinessFooterAfterLogin";
import Form from 'react-bootstrap/Form';
import API from '../../../Utils/Api';
import loader from '../../../assests/loader.gif';
import {validateswitchprofile} from '../../../Utils/validate';
import { useNavigate, Link } from 'react-router-dom';
  
import { gettoastwarning } from '../../../Utils/Common';


const SwitchNeighbourProfile = () => {
    const navigate = useNavigate();
    
    const [loading,setLoading] = useState(false);
    
    const [errors,setErrors] = useState({});
    const [inputs,setInputs] = useState({first_name:'',last_name:''});

    

    useEffect(() => {
        document.title = `Neighbour Profile | Local Bells`;
        document.getElementById('bodywrap').className = 'busieditbusi';

        /*API.post('get_state')
          .then(response => {
          setState(response.data.data);       
      });*/

    }, []);

    // State to toggle sidebar visibility
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);

    // Function to toggle sidebar visibility
    const toggleSidebar = () => {
        setIsSidebarVisible((prev) => !prev);
    };

    const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validateswitchprofile(inputs);
     const noErrors = Object.keys(validationErrors).length === 0;
        setErrors({});
        setErrors(validationErrors);
        
        if(noErrors){
                setLoading(true);
            
            let formData = new FormData(); 
            Object.keys(inputs).forEach((key) => {
            formData.append(key, inputs[key]);
        });
            API.post('add_customer_with_business_login', formData)
              .then(response => {
              if(response.data.status === false){
                //setError(response.data.message);
                setLoading(false); 
                gettoastwarning(response.data.message,'');
              }else{
                 setLoading(false);
                 localStorage.setItem("location_id", response.data.data.location_id);
                   localStorage.setItem("location_town", response.data.data.location_town_name);
                  
                    var loc='';
                    if(response.data.data.location_pincode!=='' && response.data.data.location_town_name!=='')
                    {
                      loc = `${response.data.data.location_town_name} - ${response.data.data.location_pincode}`;
                    }
                   localStorage.setItem("location", loc);
                   var is_profile_verify2=1;
                    localStorage.setItem("is_profile_verify", is_profile_verify2);
                  window.location.href = "/neighbour/local-deals";
                 //gettoastsuccess(response.data.message,'/neighbour/view-profile');
              }                  
            }).catch(error => {
               setLoading(false);
               gettoastwarning("Something went wrong. Please try again later.",'');
                //setError("Something went wrong. Please try again later.");
            });
        }
    //navigate('/neighbour/login');
  };
/* Start Value set */
const handleInputChange = (event) => {
  event.persist();
  setInputs(inputs => ({...inputs, [event.target.name]: event.target.value}));       
}
/* End Value set */



    return (
        <>
            <section className="main-cont-box">
                <Container>
                    <Row>
                        <BusinessSidebar isVisible={isSidebarVisible} setIsVisible={setIsSidebarVisible} />
                        <Col md={12} lg={9} xl={9} xxl={10} className='main-cont-box-right'>
                            <Header toggleSidebar={toggleSidebar} />
                            <div className='nei-cont'>
                                <Row>
                                    <Col md={8} lg={8} xl={7} xxl={5}>
                                        <div className='white-box edpf-box'>
                                            <div className="d-flex align-items-start justify-content-between gap-3">
                                                <h3 className='mb-3'>Switch Neighbour Profile</h3>
                                                <Link to="#" onClick={() => navigate(-1)} className='cross-up'>
                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/cross.webp'} className="img-fluid crosy" alt="wp" />
                                                </Link>
                                            </div>                                              
                                           
                                            <Form onSubmit={handleSubmit}>
                                                <Row>
                                                    <Col md={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label className=''>First Name</Form.Label>
                                                            <Form.Control type="text" placeholder="First Name" name="first_name" onChange={handleInputChange} value={inputs.first_name} />
                                                            {errors.first_name && (<p className="text-danger">{errors.first_name}</p>)}
                                                        </Form.Group>                                                    
                                                    </Col>
                                                    <Col md={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label className=''>Last Name</Form.Label>
                                                            <Form.Control type="text" placeholder="Last Name" name="last_name" onChange={handleInputChange} value={inputs.last_name} />
                                                            {errors.last_name && (<p className="text-danger">{errors.last_name}</p>)}
                                                        </Form.Group>                                                    
                                                    </Col>
                                                </Row>

                                               
                                                                                                             
                                                <Button type="submit" className='blue-btn'>Save profile</Button>
                                            </Form>                                             
                                        </div>
                                    </Col>
                                </Row>
                                <div className='footer-org footer'>
                                    <Footer />                                
                                </div>                                 
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            {loading && (
               <div className="loadingClass">
                <img src={loader} alt="loader"/>
              </div>
               )}
        </>
    )
}

export default SwitchNeighbourProfile;


